import {
  translateProductsManifest,
  type TranslateProductsProgressPhase,
} from '@foodlista/operations'
import { PRODUCTS_CACHE_KEYS } from '~/domains/products/queries'
import { registerOperationCompletionEffect } from '../completion/registry'
import { presentTranslateProducts } from '../presentation/presenters'
import { registerOperationPresenter } from '../presentation/registry'
import { registerOperationProgressTranslator } from '../progress/registry'

/**
 * Pattern B (BOC-only) operation: `AddProductToCatalog` enqueues it after the
 * products are created; progress shows only in the floating BOC and the
 * completion effect refreshes the catalog once translations are persisted.
 * No `defineScopedOperation` — there is no modal to rehydrate.
 */
registerOperationProgressTranslator(
  translateProductsManifest.type,
  (phase, t) => {
    const typed = phase as TranslateProductsProgressPhase
    switch (typed.kind) {
      case 'translating':
        return t(
          'operations.boc.progress.translateProducts.translating',
          { count: typed.count },
          typed.count,
        )
      case 'done':
        return t('operations.boc.progress.translateProducts.done')
    }
  },
)

registerOperationPresenter(
  translateProductsManifest.type,
  presentTranslateProducts,
)

registerOperationCompletionEffect(
  translateProductsManifest.type,
  async ({ restaurantSlug, queryClient }) => {
    await queryClient.invalidateQueries({
      queryKey: PRODUCTS_CACHE_KEYS.bySearch.all(restaurantSlug),
    })
  },
)
